import React from 'react';
import dynamic from 'next/dynamic';
import PageContainer from '../../../js/components/PageContainer';

const QuestionPage = dynamic(() => import('../../../js/pages/QuestionPage'), {ssr: false});

QuestionPage.getLayout = (page) => (
  <PageContainer stickyHeader hideFooter showPageBanner={false}>
    {page}
  </PageContainer>
);

export default QuestionPage;
